module.exports = __webpack_public_path__ + "img/graph_3.9f4aaec5.svg";